<script>
   /*************************************************************/
   /* ModelLoader                                               */
   /* -------------------------                                 */
   /* loads PCA model from file                                 */
   /*************************************************************/

   import { FileSelector, ButtonCancel, Container, Button } from 'svelte-controls-basic';
   import { reviver } from '../../../shared/utils';

   let { model = $bindable() } = $props();    // object with model


   // string with model file name
   let modelFile = $state('');

   // app status for handling and showing errors
   let status = $state('neutral');
   let errMsg = $state('');

   // gets model content as one large string, parse it into matrix
   function setModel(strData) {
      try{
         const m = JSON.parse(strData, reviver);
         if (Array.isArray(m.v)) {
            m.v = Float64Array.from(m.v);
         }
         if (!Object.keys(m).includes('class') || m.class[0] !== 'pcamodel') {
            throw Error('The JSON file you selected does not contain PCA model.');
         }
         m['fileName'] = modelFileName;
         model = m;
         status = 'success';
         errMsg = ''
      } catch (e) {
         console.log(e);
         model = null;
         status = 'error';
         errMsg = e;
      }
   }

   // promise for reading the CSV file
   function readFile (e) {
      const reader = new FileReader();
      reader.onload = () => { setModel(reader.result) };
      reader.readAsText(modelFile);
   }

   function reset() {
      modelFile = '';
      model = null;
      status = 'neutral';
      errMsg = '';
   }

   // reactive expression for tracking changes of 'modelFile'
   $effect(() => {
      if (modelFile === null) {
         // if model file is empty reset status and error messages
         model = null;
         status = 'neutral';
         errMsg = '';
      } else {
         // if not just remove error messages if any
         status = 'neutral';
         errMsg = '';
      }
   });

   // file name with model without extension
   let modelFileName =$derived(modelFile ? modelFile.name.replace(/\.[^/.]+$/, "") : '');
</script>

{#if !model }

   <!-- show if data is not loaded -->
   <!-- reset component if dataFile is changed inside -->
   {#key modelFile}
   <Container name="file-selector">
      <FileSelector id="modelFile" bind:file={modelFile} acceptType=".json" message="Select file with model"/>
   </Container>
   {/key}

   {#if modelFile}
   <Container name="load-button" label="&nbsp;">
      <Button onclick={readFile} text="Load" />
   </Container>
   {/if}

{:else}

   <!-- dataset is loaded - show info and cancel button -->
   <Container name="info" class="info">
      <p class="info-text">
         <span>Model file:</span> <span title={model.fileName} class="file-name">{model.fileName}</span><br>
         <span style="color:#a0a0a0;">Model info:</span> {model.ncomp} PCs{model.center ? ', centered' : ''}{model.scale ? ', scaled' : ''}
      </p>
      <ButtonCancel onclick={reset} />
   </Container>

{/if}

<!-- error message -->
{#if status === 'error' || errMsg}
<Container name="error" status="error">
   <p>{@html errMsg}</p>
</Container>
{/if}


<style>

   .info-text {
      line-height: 1.5em;
   }
   .info-text > :global(span) {
      vertical-align:top;
      color: #a0a0a0;
   }

   .info-text > .file-name {
      display: inline-block;
      padding: 0;
      margin: 0;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 25ch;
      color: #222;
   }

</style>